module.exports = __webpack_public_path__ + "media/images/info_icon-17cc94e1844952b45737cf23d44f09e3.jpeg";